module.exports = __webpack_public_path__ + "static/media/number1.97fe06ba.svg";